import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';
import { apiGetNoticeSubType } from '../../../api/notice.api';
import { Buffer } from 'buffer'; // Buffer 라이브러리 임포트
import { useData } from '../../../hooks';
import SimpleBlogCard from 'examples/Cards/BlogCards/SimpleBlogCard';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './NoticeDetail.css'; // Custom CSS 파일 임포트

// Custom Arrow Components
const CustomPrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow`}
      style={{
        ...style,
        display: 'block',
        left: '10px',
        zIndex: 1,
        transform: 'scale(2)', // Double the size
      }}
      onClick={onClick}
    />
  );
};

const CustomNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow`}
      style={{
        ...style,
        display: 'block',
        right: '10px',
        zIndex: 1,
        transform: 'scale(2)', // Double the size
      }}
      onClick={onClick}
    />
  );
};

CustomPrevArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

CustomNextArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

const NoticeDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user, appIsReady } = useData();
  const { messageType, subType } = location.state;

  useEffect(() => {
    if (appIsReady && user) {
      console.log('fetch' + JSON.stringify(user));
      fetchNotices();
    }
  }, [user, appIsReady]);

  const fetchNotices = async () => {
    setLoading(true);
    try {
      console.log('user.accessToken =' + user.accessToken);
      const response = await apiGetNoticeSubType(
        messageType,
        subType,
        user.accessToken,
      );
      console.log(response);
      if (response && Array.isArray(response)) {
        const decodedNotices = response.map((notice) => {
          const decodedContent = Buffer.from(notice.content).toString('utf8');
          console.log(decodedContent);
          return { ...notice, content: decodedContent };
        });
        setNotices(decodedNotices);
      } else {
        setNotices([]);
      }
    } catch (error) {
      console.error('Error fetching notice:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <MDTypography variant='h4' color='info'>
            Loading...
          </MDTypography>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  const settings = {
    dots: true,
    infinite: false, // Disable infinite scrolling
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        {notices.length > 0 ? (
          <Slider {...settings}>
            {notices.map((notice, index) => (
              <SimpleBlogCard
                key={index}
                image={notice.content}
                action={null}
              />
            ))}
          </Slider>
        ) : (
          <MDTypography variant='h4' color='info'>
            Notice not found
          </MDTypography>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default NoticeDetail;
